export const REPEAT_DAILY = "reportDaily";
export const REPEAT_MONTHLY = "reportMonthly";

/**
 * ActionNames
 */
export const FETCH_KYOTAKUKAIGO_DAILY_STARTED =
  "KYOTAKUKAIGO/FETCH_DAILY_STARTED";
export const FETCH_KYOTAKUKAIGO_DAILY = "KYOTAKUKAIGO/FETCH_DAILY";
export const FETCH_KYOTAKUKAIGO_DAILY_FAILED = "KYOTAKUKAIGO/FETCH_FAILED";
export const FETCH_KYOTAKUKAIGO_MONTHLY_STARTED =
  "KYOTAKUKAIGO/FETCH_MONTHLY_STARTED";
export const FETCH_KYOTAKUKAIGO_MONTHLY = "KYOTAKUKAIGO/FETCH_MONTHLY";
export const FETCH_KYOTAKUKAIGO_MONTHLY_FAILED =
  "KYOTAKUKAIGO/FETCH_MONTHLY_FAILED";
export const POST_KYOTAKUKAIGO_REPORT_STARTED = "KYOTAKUKAIGO/POST_STARTED";
export const POST_KYOTAKUKAIGO_REPORT_DAILY = "KYOTAKUKAIGO/POST_REPORT_DAILY";
export const POST_KYOTAKUKAIGO_REPORT_MONTHLY =
  "KYOTAKUKAIGO/POST_REPORT_MONTHLY";
export const POST_KYOTAKUKAIGO_REPORT_FAILED =
  "KYOTAKUKAIGO/POST_REPORT_FAILED";
export const DELETE_KYOTAKUKAIGO_REPORT_STARTED =
  "KYOTAKUKAIGO/DELETE_REPORT_STARTED";
export const DELETE_KYOTAKUKAIGO_REPORT = "KYOTAKUKAIGO/DELETE_REPORT";
export const DELETE_KYOTAKUKAIGO_REPORT_FAILED =
  "KYOTAKUKAIGO/DELETE_REPORT_FAILED";
export const POST_KYOTAKUKAIGO_REPORT_COPY_STARTED =
  "KYOTAKUKAIGO/POST_REPORT_COPY_STARTED";
export const POST_KYOTAKUKAIGO_REPORT_COPY = "KYOTAKUKAIGO/POST_REPORT_COPY";
export const POST_KYOTAKUKAIGO_REPORT_COPY_FAILED =
  "KYOTAKUKAIGO/POST_REPORT_COPY_FAILED";
export const POST_KYOTAKUKAIGO_REPORT_COPY_CARE_PLAN_STARTED =
  "KYOTAKUKAIGO/POST_REPORT_COPY_CARE_PLAN_STARTED";
export const POST_KYOTAKUKAIGO_REPORT_COPY_CARE_PLAN =
  "KYOTAKUKAIGO/POST_REPORT_COPY_CARE_PLAN";
export const POST_KYOTAKUKAIGO_REPORT_COPY_CARE_PLAN_FAILED =
  "KYOTAKUKAIGO/POST_REPORT_COPY_CARE_PLAN_FAILED";

export type KYOTAKUKAIGOReportTypeInterface = {
  type: "reportDaily" | "reportMonthly";
};

export type InoutResultsDetailsState = {
  id: number | null;
  actionClass: number | null;
  inTimeClass: string;
  inTime: string | null;
  outTimeClass: string;
  outTime: string | null;
};

export type InoutResultsState = {
  id: number | null;
  inoutResultDailyId: number | null;
  usersInFacilityId: number;
  nameSei: string;
  nameMei: string;
  targetDate: string;
  inputClass: number;
  inoutResultsPlanId: number | null;
  status: string;
  numberOfBoardingAndAlighting: number | null;
  numberOfParticipants: number | null;
  practitioner1: number | null;
  practitioner1License: number | null;
  practitioner1InTime: string;
  practitioner1OutTimeClass: string;
  practitioner1OutTime: string;
  practitioner1CalculatedHours: number | null;
  practitioner1Memo: string | null;
  inoutResultsDetails1: InoutResultsDetailsState[];
  practitioner2: number | null;
  practitioner2License: number | null;
  practitioner2InTimeClass: string;
  practitioner2InTime: string;
  practitioner2OutTimeClass: string;
  practitioner2OutTime: string;
  practitioner2CalculatedHours: number | null;
  practitioner2Memo: string | null;
  timeDuplicationJudgmentFlg: boolean;
  wholeCalculatedHours: number | null;
  duplicateCalculatedHours: number | null;
  inoutResultsDetails2: InoutResultsDetailsState[];
  licenseSameFlg: boolean;
  secondPersonFlg: boolean;
  emergencySupportFlg: boolean;
  firstAdditionFlg: boolean;
  sputumImplementationFlg: boolean;
  welfareCooperationFlg: boolean;
  facilityUnitId: number | null;
  resultExistFlg: boolean;
};

export type DisplayListState = {
  usersInFacilityId: number;
  addIconFlg: boolean;
  nameSei: string;
  nameMei: string;
  isHoliday: boolean;
  targetDate: string;
  dataList: DataListState[];
};

export type DataListState = {
  no: number | null;
  resultExistFlg: boolean;
  plan: DisplayState;
  result: DisplayState;
  planDetail: InoutResultsState;
  resultDetail: InoutResultsState;
};

export type DisplayState = {
  inoutResultsId: number | null;
  dispatchNo: number | null;
  status: number | null;
  inTime: string | null;
  outTime: string | null;
  calculatedHours: number | null;
  gettingOnAndOff: number | null;
  numberOfParticipants: number | null;
  emergencySupportFlg?: number | null;
};

export type FacilityUnitsState = {
  id: number;
  unitName: string;
  sameBuildingSubtractionFlg: boolean;
};

export type DisplayFacilityUnitsState = {
  label: string;
  value: string;
};

export type StaffsInFacilityState = {
  id: number;
  name: string;
  role: string | null;
  license: number;
};

export type DisplayStaffsInFacilityState = {
  label: string;
  value: string;
  license: string;
};

export type ReportSummary = {
  physicalCareCount: number | null;
  outpatientCareWithPhysicalCareCount: number | null;
  houseworkAssistanceCount: number | null;
  outpatientCareCount: number | null;
  gettingOnAndOffCount: number | null;
};

export type ReportState = {
  reportDaily: {
    inoutResultDaily: {
      targetDate: string | null;
    };
    facilityUnits: FacilityUnitsState[];
    staffsInFacility: StaffsInFacilityState[];
    displayFacilityUnits: DisplayFacilityUnitsState[];
    displayStaffsInFacility: DisplayStaffsInFacilityState[];
    displayList: DisplayListState[];
    planCount: number;
  };
  reportMonthly: {
    summary: ReportSummary;
    facilityUnits: FacilityUnitsState[];
    staffsInFacility: StaffsInFacilityState[];
    displayFacilityUnits: DisplayFacilityUnitsState[];
    displayStaffsInFacility: DisplayStaffsInFacilityState[];
    displayList: DisplayListState[];
    planCount: number;
  };
};

export type DeleteReportState = {
  uifId: number;
  targetDate: string;
  inoutResultsId: number | null;
  inputClass: number;
};

export type CopyReportState = {
  uifId: number;
  targetDate: string;
  inoutResultsId?: number | null;
};

export type CopyReportErrorState = {
  response: {
    code: number;
    msg: string;
  };
};
